import React, { useState } from 'react'
import classNames from 'classnames'
import { OverlayTrigger, Popover } from 'react-bootstrap'
import { NO_OWNER_SEE_WHO, SKIPPED_OPEN_IN_RESULTS, skippedShowAll } from './sendBookingInvitationsCopy'
import styles from './SkippedClientsPopover.module.scss'

export interface SkippedClientName {
  id: string
  name: string
  detail?: string
}

export interface SkippedClientsGroup {
  key: string
  title: string
  clients: SkippedClientName[]
}

const VISIBLE_NAMES = 5

const LINK_CLASS_NAME = 'btn btn-link p-0 border-0 align-self-start paragraph-small zocks-text-primary text-decoration-none'

const NameList: React.FC<{ clients: SkippedClientName[] }> = ({ clients }) => {
  const [expanded, setExpanded] = useState(false)
  const shown = expanded ? clients : clients.slice(0, VISIBLE_NAMES)
  return (
    <div className='d-flex flex-column gap-1'>
      {shown.map((client) => (
        <span key={client.id} className='paragraph-small zocks-text-gray-900'>
          {client.name}
          {client.detail ? <span className='zocks-text-gray-600'> · {client.detail}</span> : null}
        </span>
      ))}
      {!expanded && clients.length > VISIBLE_NAMES ? (
        <button type='button' className={LINK_CLASS_NAME} onClick={() => setExpanded(true)}>
          {skippedShowAll(clients.length)}
        </button>
      ) : null}
    </div>
  )
}

interface SkippedClientsPopoverProps {
  groups: SkippedClientsGroup[]
  onOpenInResults?: () => void
}

export const SkippedClientsPopover: React.FC<SkippedClientsPopoverProps> = ({ groups, onOpenInResults }) => (
  <OverlayTrigger
    trigger='click'
    rootClose
    placement='bottom-start'
    overlay={
      <Popover>
        <Popover.Body className={classNames('d-flex flex-column p-0', styles.body)}>
          <div className={classNames('d-flex flex-column px-3 pb-3 overflow-auto', styles.scroll)}>
            {groups.map((group) => (
              <section key={group.key} className='d-flex flex-column gap-2'>
                <span className={classNames('fw-600 zocks-text-gray-900 zocks-bg-color-white pt-3 pb-1', styles.groupHeader, styles.groupTitle)}>
                  {group.title}
                </span>
                <NameList clients={group.clients} />
              </section>
            ))}
          </div>
          {onOpenInResults ? (
            <div className='border-top zocks-border-color-gray-200 px-3 py-2'>
              <button type='button' className={LINK_CLASS_NAME} onClick={onOpenInResults}>
                {SKIPPED_OPEN_IN_RESULTS}
              </button>
            </div>
          ) : null}
        </Popover.Body>
      </Popover>
    }
  >
    <button type='button' className='btn btn-link p-0 border-0 align-baseline paragraph-small zocks-text-primary'>
      {NO_OWNER_SEE_WHO}
    </button>
  </OverlayTrigger>
)
